<template>
    <button type="button" :class="buttonClass" @click="sign">
        {{ buttonName }}
    </button>
</template>

<script>
import {signXmlCall} from '../ncalayer/process-ncalayer-calls';
import {unblockScreen} from '../ncalayer/ncalayer.lib';

export default {
    name: 'Sign',
    props: {
        buttonName: String,
        buttonClass: {
            type: String,
            default: 'btn btn-success',
        },
        xml: String,
        keyType: String,
    },
    methods: {
        sign() {
            signXmlCall(this.xml, this.keyType, 'PKCS12', (result) => {
                unblockScreen();
                if (result.code === '200') {
                    this.$emit('xmlReady', result.responseObject);
                } else {
                    const message = result.message === 'action.canceled'
                        ? 'Подписание отменено.'
                        : 'Не удалось выполнить подписание.';
                    alert(message);
                }
            });
        },
    },
};
</script>
